import React from "react";
import useModal from "../../../hooks/useModal";
import trash from "../../../assets/icons/trash.svg";
import send from "../../../assets/icons/send.svg";
import { sendBackMail } from "../../../services/Api/userService";
import { usePartnerStore } from "../../../stores/admin/users";
import { showToastError, showToastSuccess } from "../../../services/Toasts/toasts";
import { dateFormat } from "../../../services/Utils/functionService";
import DeleteUser from "../Modales/DeleteUser";

const CustomerAdminTable = () => {
  // Store
  const { usersCustomer } = usePartnerStore();

  // Hook
  const { modalContent, isModalOpen, openModal, closeModal } = useModal();

  // Function to send back mail to user
  const handleSendBack = (idUser: number) => {
    sendBackMail(idUser)
      .then(() => showToastSuccess("L'email a bien été envoyé à l'utilisateur"))
      .catch(() => showToastError("Une erreur s'est produite"));
  };

  return (
    <div className="w-full h-full">
      {isModalOpen ? modalContent : null}
      
      {/* En-têtes de colonnes avec design moderne */}
      <div className="bg-gray-50 border-b border-gray-200 px-6 py-4 sticky top-0">
        <div className="grid grid-cols-7 gap-4 text-sm font-semibold text-gray-700">
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Nom
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Prénom
            </span>
          </div>
          <div className="col-span-2 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Email
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0H8m8 0a2 2 0 012 2v8a2 2 0 01-2 2H8a2 2 0 01-2-2V8a2 2 0 012-2z" />
              </svg>
              Titre
            </span>
          </div>
          <div className="col-span-1 flex items-center">
            <span className="flex items-center gap-2">
              <svg className="w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Dernière connexion
            </span>
          </div>
          <div className="col-span-1 flex items-center justify-center">
            <span className="text-center">Actions</span>
          </div>
        </div>
      </div>

      {/* Corps de la table avec design moderne */}
      <div className="w-full overflow-y-auto max-h-[calc(90vh-20rem)]">
        {usersCustomer?.length === 0 || usersCustomer === undefined ? (
          <div className="text-center py-12">
            <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
              <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun client trouvé</h3>
            <p className="text-gray-500">Aucun client partenaire n'a été trouvé.</p>
          </div>
        ) : (
          usersCustomer?.map((user: any) => (
            <div
              key={user?.id}
              className="w-full hover:bg-blue-50 transition-all duration-200 border-b border-gray-100 grid grid-cols-7 gap-4 px-6 py-4"
            >
              {/* Nom */}
              <div className="col-span-1 flex items-center">
                <div className="font-medium text-gray-900">{user?.lastName}</div>
              </div>
              
              {/* Prénom */}
              <div className="col-span-1 flex items-center">
                <div className="text-gray-700">{user?.firstName}</div>
              </div>
              
              {/* Email */}
              <div className="col-span-2 flex items-center">
                <div className="text-gray-600 text-sm truncate">{user?.eMail}</div>
              </div>
              
              {/* Titre */}
              <div className="col-span-1 flex items-center">
                <div className="text-gray-700">{user?.titre || '-'}</div>
              </div>
              
              {/* Dernière connexion */}
              <div className="col-span-1 flex items-center">
                {user?.lastConnection === null ? (
                  <div className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
                    Jamais connecté
                  </div>
                ) : (
                  <div className="text-gray-600 text-sm">
                    {dateFormat(user?.lastConnection)}
                  </div>
                )}
              </div>

              {/* Actions */}
              <div className="col-span-1 flex items-center justify-center gap-2">
                {/* Bouton Envoyer */}
                <button 
                  onClick={() => handleSendBack(user.id)}
                  className="p-2 bg-green-100 hover:bg-green-200 rounded-lg transition-colors duration-200 cursor-pointer group"
                  title="Envoyer un email"
                >
                  <img 
                    src={send} 
                    alt="icon envoyer" 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                  />
                </button>
                  {/* Bouton Supprimer */}
                  <button
                  type="button"
                  className="p-2 bg-red-100 hover:bg-red-200 rounded-lg transition-colors duration-200 cursor-pointer group"
                  onClick={() => {
                    openModal(
                      <DeleteUser idUser={user?.id} closeModal={closeModal} />
                    );
                  }}
                  title="Supprimer"
                >
                  <img 
                    className="w-4 h-4 group-hover:scale-110 transition-transform duration-200" 
                    src={trash} 
                    alt="poubelle" 
                  />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default React.memo(CustomerAdminTable);
